import { render } from "./ModalWarning.vue?vue&type=template&id=0202f074"
import script from "./ModalWarning.vue?vue&type=script&lang=js"
export * from "./ModalWarning.vue?vue&type=script&lang=js"

import "./ModalWarning.vue?vue&type=style&index=0&id=0202f074&lang=css"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__